const hasImage = function hasImage(item) {

    try {

        return item.thumbnails && item.thumbnails !== '' && item.thumbnails.image && item.thumbnails.image.length > 0;
    } catch (error) {

        console.dir(item, {depth: null});
        console.error(error)
    }

};

module.exports = {
    jsonParse: data => {
        return JSON.parse(data);
    },
    // 格式化推荐位
    formatRecommendedBit: (options, key, commonIdArray = [], type = undefined) => data => {
        const result = [];
        const olen = options.length;
        let i = 0;
        const dlen = data.length;
        let j = 0;

        while (i < olen && j < dlen) {
            const { id, title, url, thumbnail, thumbnails, summary, marquee, children } = data[j];
            let image = '';

            if (thumbnail && thumbnail !== '') {
                image = thumbnail;
            } else if (thumbnails && thumbnails !== '' && thumbnails.image.length > 0) {
                image = thumbnails.image[0].url;
            }

            // 格式化同行
            let formatChildren = undefined;

            if (children && children.length > 0) {
                formatChildren = [];

                for (const childrenItem of children) {
                    formatChildren.push({ title: childrenItem.title, url: childrenItem.url });
                }
            }

            if (!commonIdArray.includes(id) || options.repeat === false) {
                const fItem = { id, title, url, thumbnail: image, summary, marquee, children: formatChildren };

                if (type === 'recommendFragment') fItem.notFormatUrl = true; // 不格式化地址
                result.push(fItem);
                // if(id){commonIdArray.push(id)};
                if(id && options.repeat !== false){commonIdArray.push(id)};
                i += 1;
            }

            j += 1;
        }

        return result;
    },
    // 格式化原创栏目信息
    formatRelateOriginalCategory: (options, key, commonIdArray = [], type = undefined) => data => {
        const result = [];
        const olen = options.length;
        let i = 0;
        const dlen = data.length;
        let j = 0;

        while (i < olen && j < dlen) {
            const { id, title, url, thumbnails, videoCount, columns, newsTime, thumbnail, articleTag } = data[j]; // videoCount：是否有视频
            // 兼容图片
            let img = thumbnails;

            try {
                if (typeof thumbnails === 'string' && thumbnails !== '') img = JSON.parse(thumbnails);
            } catch (err) {
                /* 什么也不干 */
            }

            if (!hasImage(data[j]) && thumbnail && thumbnail !== '') img = { image: [{ url: thumbnail }] };

            if (!commonIdArray.includes(id) || options.repeat === false) {
                const fItem = { id, title, url, thumbnails: img, videoCount, newsTime, thumbnail, columns, articleTag };

                if (type === 'recommendFragment') fItem.notFormatUrl = true; // 不格式化地址
                result.push(fItem);
                // if(id){commonIdArray.push(id)};
                if(id && options.repeat !== false){commonIdArray.push(id)};
                i += 1;
            }

            j += 1;
        }

        return result;
    },
    // 格式化信息流推荐位
    formatNewsStream: (options, key, commonIdArray = [], type = undefined) => data => {
        const result = [];
        const olen = options.length;
        let i = 0;
        const dlen = data.length;
        let j = 0;

        while (i < olen && j < dlen) {
            const {
                id,
                title,
                url,
                commentUrl,
                skey,
                newsTime,
                source,
                type,
                thumbnails,
                thumbnail,
                videoCount,
                guid,
            } = data[j];
            // 兼容图片
            let img = thumbnails;

            try {
                if (typeof thumbnails === 'string' && thumbnails !== '') img = JSON.parse(thumbnails);
            } catch (err) {
                /* 什么也不干 */
            }

            if (!hasImage(data[j]) && thumbnail && thumbnail !== '') img = { image: [{ url: thumbnail }] };

            if (!commonIdArray.includes(id) || options.repeat === false) {
                const fItem = {
                    id,
                    title,
                    url,
                    commentUrl,
                    skey,
                    newsTime,
                    source,
                    type,
                    thumbnails: img,
                    videoCount,
                    guid,
                };

                if (type === 'recommendFragment') fItem.notFormatUrl = true; // 不格式化地址
                result.push(fItem);
                // if(id){commonIdArray.push(id)};
                if(id && options.repeat !== false){commonIdArray.push(id)};
                i += 1;
            }

            j += 1;
        }

        return result;
    },
    // 格式化时间线
    formatTimeLine: (options, key, commonIdArray = [], type = undefined) => data => {
        const result = [];
        const olen = options.length;
        let i = 0;
        const dlen = data.length;
        let j = 0;

        while (i < olen && j < dlen) {
            const { id, title, summary } = data[j];

            if (!commonIdArray.includes(id) || options.repeat === false) {
                const fItem = { title, summary };

                result.push(fItem);
                // if(id){commonIdArray.push(id)};
                if(id && options.repeat !== false){commonIdArray.push(id)};
                i += 1;
            }

            j += 1;
        }

        return result;
    },
    // 格式化广告
    formatAdData: (options, key) => data => key,
    // 不格式化
    notranslate: (options, key, commonIdArray = []) => data => data,

    /**
     * @param {Array} data 待处理的数据
     * @param {Number} length 截取的长度
     * @param {Number} type 待处理的数据来源 0 tv 1 v
     */
    handleVideoStream: (data, length = 25, type) => {
        const toLink = [
            '//tv.ifeng.com/c/',
            '//v.ifeng.com/c/'
        ];

        try {
            return data.slice(0, length).map(item => ({
                posterUrl: item.posterUrl,
                title: item.title,
                columnName: item.columnName || item.wemediaEAccountName,
                newsTime: item.newsTime,
                duration: item.duration,
                guid: item.guid,
                base62Id: item.base62Id,
                url: item.base62Id ? `${toLink[type]}${item.base62Id}` : item.url,
                type: item.type,
                thumbnails: item.thumbnails,
                commentUrl: item.commentUrl
            }));
        } catch (e) {
            console.error(e);
        }
    },
};
